import { BooleanField, DateField, FunctionField, ListProps, ShowButton, TextField } from 'react-admin';
import { AdverseFilter } from '@/pages/AdverseAction/actions';
import { PillButtonField } from '@/components/fields';
import { ColorMap } from '@/components/fields/PillButtonField/types';
import { STATUS_COLOR_MAP, STATUS_VALUE_MAP } from '@/pages/AdverseAction/constants';
import { MainDatagridStyled, MainListStyled } from '@/styles/overrides';
import { path } from './constants';

const AdverseList = (props: Partial<ListProps>) => (
  <MainListStyled
    filters={<AdverseFilter />}
    sort={{ field: 'id', order: 'DESC' }}
    storeKey={false}
    title="Adverse"
    {...props}
  >
    <MainDatagridStyled bulkActionButtons={false} className="turn-main-list" rowClick={false}>
      <TextField source={path('display_name')} label="Name" />
      <PillButtonField
        sortable={false}
        source={path('adverse.preadverse')}
        label="Pre-Adverse Action"
        valueMap={STATUS_VALUE_MAP}
        colorMap={STATUS_COLOR_MAP as ColorMap}
      />
      <DateField sortable={false} source={path('adverse.pa_date_sent')} emptyText="-" label="Date PA Sent" />
      <PillButtonField
        sortable={false}
        source={path('adverse.adverse')}
        label="Adverse Action"
        valueMap={STATUS_VALUE_MAP}
        colorMap={STATUS_COLOR_MAP as ColorMap}
      />
      <DateField sortable={false} source={path('adverse.aa_date_sent')} emptyText="-" label="Date AA Sent" />
      <TextField source={path('partner_name')} label="Partner" />
      <PillButtonField
        sortable={false}
        source={path('adverse.status')}
        label="Status"
        valueMap={STATUS_VALUE_MAP}
        colorMap={STATUS_COLOR_MAP as ColorMap}
      />
      <BooleanField sortable={false} source={path('adverse.dispute')} label="Dispute" />
      <ShowButton />
    </MainDatagridStyled>
  </MainListStyled>
);

export default AdverseList;
